export default defineI18nConfig(() => ({
    legacy: false,
    // this can't be no_prefix for the custom paths to work for pages
}))
